export default __webpack_public_path__ + "static/TheIndianaJonesoftheCaribbean-969e5f9e2f5f18823a8eb31cb831e0f4.jpg";